// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"487":"f653bfd8","990":"e908f2ea"}[chunkId] + ".chunk.js";
};